import { Container } from "./styles";

import profileImage from "../../assets/FotoPC.webp"
import cssIcon from "../../assets/css-icon.svg";
import htmlIcon from "../../assets/html-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import vueIcon from "../../assets/vue-icon.svg";


export function About(){
  return(
    <Container id="sobre">
		<div className="about-image">
          <img src={profileImage} alt="Cristina Jover" />
      </div>
      <div className="about-text">
          <h2>Sobre mí</h2>
          <p>Apasionada por la tecnología, los puzzles y por verle las «tripas» a las herramientas que usamos día a día, la vida me llevó tras graduarme en Periodismo a estudiar programación.</p>
          <p>Con buena parte de formación externa, pero también mucho de autodidacta, voy día a día aprendiendo sobre programación y sobre nuevas tecnologías en general, enfocándome especialmente en diseñar y crear páginas web.</p>
          <p>Tengo una curiosidad innata que me lleva a investigar en todas las áreas posibles, como en el diseño gráfico, la escritura creativa, el arte abstracto o la inteligencia artificial.</p>
          <h3>Estas son algunas de mis <i>skills</i>:</h3>
        <div className="hard-skills">
          <div className="hability">
              <img src={reactIcon} alt="React" />
          </div>

          <div className="hability">
            <img src={vueIcon} alt="Vue" />
          </div>

          <div className="hability">
            <img src={jsIcon} alt="JavaScript" />
          </div>

          <div className="hability">
            <img src={htmlIcon} alt="Html" />
          </div>

          <div className="hability">
            <img src={cssIcon} alt="Css" />
          </div>
          <div className="hability">
            <img src={nodeIcon} alt="Node" />
          </div>

          <div className="hability">
            <img src={typescriptIcon} alt="Typescript" />
          </div>


        </div>
      </div>
      
    </Container>
  )
}
